import React from 'react/addons';
import cx from 'classnames';
import _ from 'underscore';
import moment from 'moment';
import {gettext} from 'ofs/i18n';

import InfoTip from 'ofs/components/common/InfoTip';

const messages = {
  FREE: gettext('Free'),
};

const AppointmentChoice = React.createClass({
  contextTypes: {
    flux: React.PropTypes.object
  },

  handleSelect() {
    const model = this.props.model.appointment || this.props.model;
    const {appointment} = this.props;
    const value = {
      time: appointment.appointment_time,
      type: appointment.appointment_type.key
    };

    model.set({
      selected_appointment: value,
    });
  },

  preventBubbling(event) {
    event.stopPropagation();
    return;
  },

  render() {
    const model = this.props.model.appointment || this.props.model;
    const {appointment} = this.props;
    const {config} = this.props;

    const value = {
      time: appointment.appointment_time,
      type: appointment.appointment_type.key
    };

    const selected = _.isEqual(value, model.get('selected_appointment'));
    const rowClasses = cx({
      'ofs-Appointments__Row': true,
      'ofs-Appointments__Row--selected': selected
    });

    let price;
    const selectedAndDescription = appointment.appointment_type.description && selected;
    const notSelectedAndDescription = appointment.appointment_type.description && !selected;

    if (appointment.amount !== '0.00') {
      price = <div className="ofs-Appointments__Price"><span className="ofs-InfoTip__Label ofs-InfoTip__Label--left"><span className="currency" dangerouslySetInnerHTML={{__html: config.currency_symbol}} />{appointment.amount}</span>{notSelectedAndDescription ? <span onClick={this.preventBubbling}><InfoTip flux={this.context.flux} small={true}>{appointment.appointment_type.description}</InfoTip></span> : null}</div>;
    } else {
      price = <div className="ofs-Appointments__Price"><span className="ofs-InfoTip__Label ofs-InfoTip__Label--left">{messages.FREE}</span>{notSelectedAndDescription ? <span onClick={this.preventBubbling}><InfoTip flux={this.context.flux} small={true}>{appointment.appointment_type.description}</InfoTip></span>: null}</div>;
    }

    return (
      <tr className={rowClasses} onClick={this.handleSelect}>
        <td className="ofs-Appointments__Cell ofs-Appointments__Cell--time">
          <input className="u-hide" type="radio" checked={selected} name="selected_appointment" onChange={this.handleSelect} />
          <span className="ofs-TravelTime__Info">{moment(appointment.appointment_time, "YYYY-MM-DDTHH:mm").format('HH:mm')}</span>
        </td>
        <td className="ofs-Appointments__Cell ofs-Appointments__Cell--body">
          <span className="u-text-bold">{appointment.appointment_type.label}</span> 
          {selectedAndDescription ? <div className="ofs-Appointments__Description">{appointment.appointment_type.description}</div> : null}
        </td>
        <td className="ofs-Appointments__Cell ofs-Appointments__Cell--price">
          {price}
        </td>
      </tr>
    );
  }
});

export default AppointmentChoice;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/_AppointmentChoice.jsx
 **/